angular.module('components.caMapOrDate', [])
    .component('caMapOrDate', {
        templateUrl: 'main/product/productimport/components/mapordate.component.tpl.html',
        controllerAs: 'vm',
        bindings: {
            dateModel: '=',
            dateMin: '<',
            dateMax: '<',
            columnNames: '<',
            columnModel: '=',
            columnOrderBy: '<',
            columnItemRenderer: '<',
            columnFilterBy: '<',
            columnPlaceholder: '<',
            disabledBy: '<'
        },
        controller: controller
    });

// @ngInject
function controller($scope, GenericComponentService) {
    var vm = this;
    vm.$onChanges = onChanges;
    vm.$onInit = onInit;

    //Properties
    vm.multiplicity = 'single';
    vm.mandatory = true;

    //Methods
    vm.filterColumn = filterColumn;

    function onInit() {
        resolveRenderer();

        $scope.$watch(function() { return (vm.multiplicity); }, function(oldValue, newValue) {
            if (oldValue !== newValue) {
                if (vm.multiplicity === 'single') {
                    vm.columnModel = undefined;
                } else if (vm.multiplicity === 'multiple') {
                    vm.dateModel = undefined;
                }
            }
        });
    }

    function onChanges(changes) {
        if (changes.columnRenderItem) {
             resolveRenderer();
        }
    }

    function resolveRenderer() {
        vm.columnRenderItem = GenericComponentService.resolveSelectRenderer(vm.columnItemRenderer);
    }

    function filterColumn(query) {
        return GenericComponentService.getSelectFilter(query, vm.columnFilterBy);
    }
}
